<template>
  <div class="spinnerContainer">Loading please wait...</div>
</template>
<script>
import { some as _some, map as _map } from 'lodash-es';
export default {
  name: 'HomeLoading',
  beforeCreate() {
    let isSecretShopper = _some(this.$auth.user().roles, {
      name: 'secret-shopper',
    });

    let isAccountManager = _some(this.$auth.user().roles, {
      name: 'account-manager',
    });

    let isSpecificDealerManager = _some(this.$auth.user().roles, {
      name: 'specific-dealer-manager',
    });

    let isSuperAdmin = _some(this.$auth.user().roles, {
      name: 'super-administrator',
    });

    if (isSecretShopper || isSuperAdmin) {
      return this.$router.push({ name: 'Secret Shop Management' });
  }

    return this.$router.push({
      name: 'Secret Shops'
    });
  },
};
</script>
